import FauzyLogic from "@/components/FauzyLogic";
const About = () => {
  return (
    <div className="min-h-screen bg-white" style={{fontFamily: '"EB Garamond", serif'}}>
      <div className="max-w-6xl mx-auto px-6 py-16 space-y-24">
        {/* Hero Section */}
        <div className="text-center space-y-8 py-12">
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-200/40 blur-3xl rounded-full"></div>
              <img
                src="/fauzylogic-logo-sigma-light-circle-white-ring-light-blue-fat-60-outside-alpha.png"
                alt="FauzyLogic Sigma Logo"
                className="relative h-28 w-28 md:h-36 md:w-36 object-contain"
                style={{ filter: 'drop-shadow(0 2px 12px rgba(0,0,0,0.10))' }}
              />
            </div>
          </div>
          <div className="space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight">
              <span className="text-fauzy-orange">Fauzy</span><span className="text-fauzy-blue">Logic</span><span className="text-gray-800">: Elevate Debate</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              FauzyLogic is an online platform designed to foster critical thinking, nuanced discussion, and genuine understanding in social discourse.
            </p>
          </div>
          <div className="flex justify-center space-x-4 pt-4">
            <a 
              href="mailto:info@fauzylogic.com" 
              className="px-6 py-2.5 text-sm border-2 rounded-md transition-all font-medium"
              style={{borderColor: '#4A90E2', color: '#4A90E2'}}
            >
              Feedback
            </a>
            <a 
              href="mailto:info@fauzylogic.com" 
              className="px-6 py-2.5 text-sm border-2 rounded-md transition-all font-medium"
              style={{borderColor: '#4A90E2', color: '#4A90E2'}}
            >
              Join Beta
            </a>
          </div>
        </div>

        {/* What is FauzyLogic? */}
        <section className="space-y-10 py-12 px-8 rounded-2xl" style={{backgroundColor: '#E8F4F8'}}>
          <h2 className="text-3xl font-bold text-center text-gray-800">What is <FauzyLogic />?</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 rounded-lg bg-white space-y-3">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{backgroundColor: '#4A90E2'}}>
                <span className="text-white text-xl">👤</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">User Control</h3>
              <p className="text-gray-600 leading-relaxed">Empowering individuals to shape their debate experience.</p>
            </div>
            <div className="p-6 rounded-lg bg-white space-y-3">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{backgroundColor: '#4A90E2'}}>
                <span className="text-white text-xl">💡</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Critical Thinking</h3>
              <p className="text-gray-600 leading-relaxed">Encouraging deep analysis and reasoned argumentation.</p>
            </div>
            <div className="p-6 rounded-lg bg-white space-y-3">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{backgroundColor: '#4A90E2'}}>
                <span className="text-white text-xl">📋</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Ideas-Centric</h3>
              <p className="text-gray-600 leading-relaxed">Focusing on the substance of arguments, not personalities.</p>
            </div>
            <div className="p-6 rounded-lg bg-white space-y-3">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{backgroundColor: '#4A90E2'}}>
                <span className="text-white text-xl">👥</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Community</h3>
              <p className="text-gray-600 leading-relaxed">Building a space for respectful and constructive engagement.</p>
            </div>
          </div>
        </section>

        {/* Pain Points */}
        <section className="space-y-10">
          <h2 className="text-3xl font-bold text-center text-gray-800">Addressing Pain Points for Critical Thinkers</h2>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
            {/* ...existing code... */}
          </div>
          <div className="flex justify-center">
            <img 
              src="https://cdn.gamma.app/f0qw4paxuhrx81b/generated-images/OgbHs3JANWWa85THFD0p-.jpg" 
              alt="Person considering multiple perspectives" 
              className="rounded-xl max-w-md w-full"
            />
          </div>
        </div>
        </section>

        {/* Core Problems */}
        <section className="space-y-10 py-12 px-8 rounded-2xl" style={{backgroundColor: '#E8F4F8'}}>
          <h2 className="text-3xl font-bold text-center text-gray-800">How <FauzyLogic /> Solves Core Problems</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center space-y-4 p-6">
              <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" style={{backgroundColor: '#4A90E2'}}>
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Trust</h3>
              <p className="text-gray-600 leading-relaxed">
                Bridges divides by providing a neutral space for examining beliefs without the filter of partisan media.
              </p>
            </div>
            <div className="text-center space-y-4 p-6">
              <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" style={{backgroundColor: '#4A90E2'}}>
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Reach</h3>
              <p className="text-gray-600 leading-relaxed">
                Facilitates cross-pollination of ideas, allowing perspectives from different "echo chambers" to interact constructively.
              </p>
            </div>
            <div className="text-center space-y-4 p-6">
              <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" style={{backgroundColor: '#4A90E2'}}>
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Nuance</h3>
              <p className="text-gray-600 leading-relaxed">
                Promotes in-depth discussion where shouting is replaced by listening, enabling education and persuasion.
              </p>
            </div>
          </div>
            <p className="text-center text-gray-600 text-base max-w-3xl mx-auto leading-relaxed">
              <FauzyLogic />'s tools enable users to easily explore inconsistencies within their own beliefs, and compare them with "the other side."
            </p>
        </section>

        {/* Debating Process */}
        <section className="space-y-8 py-12 px-8 rounded-2xl" style={{backgroundColor: '#E0F2FE'}}>
          <h2 className="text-3xl font-bold text-gray-800">Debating "The Other Side": A New Approach</h2>
          <div className="grid md:grid-cols-2 gap-8 items-start">
            <div className="space-y-6">
              <div className="space-y-2">
                <div className="text-gray-500 text-sm font-medium">01</div>
                <h3 className="text-xl font-semibold text-gray-800">Identify Inconsistencies</h3>
                <p className="text-gray-600 leading-relaxed">
                  <FauzyLogic /> helps you find logical inconsistencies within "the other side's" stated beliefs.
                </p>
              </div>
              <div className="space-y-2">
                <div className="text-gray-500 text-sm font-medium">02</div>
                <h3 className="text-xl font-semibold text-gray-800">Compare Belief Systems</h3>
                <p className="text-gray-600 leading-relaxed">
                  Easily compare "the other side's" beliefs with your own to pinpoint areas of divergence.
                </p>
              </div>
              <div className="space-y-2">
                <div className="text-gray-500 text-sm font-medium">03</div>
                <h3 className="text-xl font-semibold text-gray-800">Add Context</h3>
                <p className="text-gray-600 leading-relaxed">
                  Provide your perspective and supporting context, ensuring that any reader of "the other side's" view also sees yours.
                </p>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://cdn.gamma.app/f0qw4paxuhrx81b/generated-images/RG6oVdPrWJjYnUV1Kb6zm.jpg" 
                alt="Two individuals with ideas flowing between them" 
                className="rounded-xl max-w-md w-full"
              />
            </div>
          </div>
          <p className="text-gray-600 italic text-center">
            FauzyLogic facilitates constructive debate by structuring information to highlight points of contention and allowing users to directly address them with their own context. This promotes a more informed and balanced understanding for all participants.
          </p>
        </section>

        {/* Enhancing Nuance */}
        <section className="space-y-8 py-12">
          <div className="space-y-4">
            <h2 className="text-3xl font-bold">Enhancing Nuance in Discussion</h2>
            <p className="text-gray-600 leading-relaxed">
              <FauzyLogic /> empowers users to add depth and clarity to any belief or statement. Our platform facilitates a comprehensive approach to understanding complex topics.
            </p>
          </div>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{backgroundColor: '#0066CF'}}>
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-1">Context</h3>
                <p className="text-gray-600">Providing relevant background and surrounding information.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{backgroundColor: '#0066CF'}}>
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-1">Clarity</h3>
                <p className="text-gray-600">Ensuring ideas are easy to understand and free from ambiguity.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{backgroundColor: '#0066CF'}}>
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-1">Concision</h3>
                <p className="text-gray-600">Expressing ideas effectively with brevity.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{backgroundColor: '#0066CF'}}>
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-1">Precision</h3>
                <p className="text-gray-600">Achieving exactness and accuracy in statement.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{backgroundColor: '#0066CF'}}>
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-1">Accuracy</h3>
                <p className="text-gray-600">Ensuring information is factually correct and free from errors.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Neutrality */}
        <section className="space-y-6 p-10 rounded-2xl" style={{backgroundColor: '#E0F2FE'}}>
          <h2 className="text-3xl font-bold text-gray-800"><FauzyLogic />'s Commitment to Neutrality</h2>
          <blockquote className="border-l-4 border-fauzy-blue pl-6 py-2 text-lg">
            <p className="leading-relaxed text-gray-700">
              <FauzyLogic />'s role is to help you debate nuanced and controversial topics. <FauzyLogic /> is neutral. <FauzyLogic />'s goal is to help you and "the other side" have a nuanced debate, so you can each decide for yourself.
            </p>
          </blockquote>
          <p className="text-gray-600 leading-relaxed">
            We respect everyone's right to decide what to believe for themselves. Debating and learning is crucial to both the scientific and Socratic methods. History shows even long-held scientific beliefs can evolve. <FauzyLogic /> is designed to facilitate this dynamic process, promoting open inquiry over predetermined conclusions.
          </p>
          <div className="p-4 rounded-lg" style={{backgroundColor: '#E0F2FE'}}>
            <p className="text-gray-600 leading-relaxed">
              📝 While <FauzyLogic /> upholds unfettered free speech as necessary for science, philosophy, and democracy, the platform always complies with all local laws.
            </p>
          </div>
        </section>

        {/* Distinguishing Features */}
        <section className="space-y-8 py-16 px-12 rounded-2xl" style={{backgroundColor: '#2B2B3D'}}>
          <h2 className="text-3xl font-bold text-white">Distinguishing <FauzyLogic /> from Other Platforms</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <strong className="text-white">Wikipedia:</strong> <FauzyLogic /> <span className="text-gray-300">facilitates robust debate from diverse perspectives; Wikipedia aims for neutral definitions.</span>
              </div>
              <div>
                <strong className="text-white">X (formerly Twitter):</strong> <FauzyLogic /> <span className="text-gray-300">focuses on critical thinking and idea relationships; X is often characterized by echo chambers and superficial engagement.</span>
              </div>
              <div>
                <strong className="text-white">Reddit:</strong> <FauzyLogic /> <span className="text-gray-300">connects ideas for continuous debate and refinement; Reddit relies on moderators and threads often go stale.</span>
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <strong className="text-white">Facebook:</strong> <FauzyLogic /> <span className="text-gray-300">prioritizes relationships between ideas and belief systems, not personal social connections.</span>
              </div>
              <div>
                <strong className="text-white">Online News Sources:</strong> <FauzyLogic /> <span className="text-gray-300">enables multi-directional, bite-sized communication; news sources are primarily one-way with limited, unintegrated comments. We put users in control of messaging and quality.</span>
              </div>
            </div>
          </div>
          <p className="text-gray-300 italic leading-relaxed">
            <FauzyLogic /> stands apart by fostering deep, structured discussions around ideas, prioritizing user control and nuanced understanding over quick interactions or singular narratives. Our revenue model supports this by focusing on promoting debate awareness, not advertising impressions, reducing pressure for censorship.
          </p>
        </section>

        {/* Revenue Model */}
        <section className="space-y-8 py-12">
          <h2 className="text-3xl font-bold">Our Revenue Model: Supporting Uncensored Debate</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="p-6 rounded-xl space-y-3" style={{backgroundColor: '#E0F2FE'}}>
              <h3 className="text-xl font-semibold text-gray-800">Promote Ideas</h3>
              <p className="text-gray-600 leading-relaxed">
                Users can pay to increase the visibility of their ideas, ensuring broader exposure for their arguments.
              </p>
            </div>
            <div className="p-6 rounded-xl space-y-3" style={{backgroundColor: '#E0F2FE'}}>
              <h3 className="text-xl font-semibold text-gray-800">Subscription Fees</h3>
              <p className="text-gray-600 leading-relaxed">
                Subscribers can enjoy an ad-free experience and additional features.
              </p>
            </div>
            <div className="p-6 rounded-xl space-y-3" style={{backgroundColor: '#E0F2FE'}}>
              <h3 className="text-xl font-semibold text-gray-800">Contribute to Quality</h3>
              <p className="text-gray-600 leading-relaxed">
                Users can contribute to improving the overall quality of debate, either financially or through direct engagement.
              </p>
            </div>
          </div>
            <p className="text-gray-600 leading-relaxed">
              <FauzyLogic /> is not "pay to win." Payment increases visibility, but the convincing power lies solely in the quality of the ideas presented. This model prevents advertising-driven censorship and ensures the platform's neutrality.
            </p>
        </section>

        {/* Footer Navigation */}
        <div className="flex justify-center space-x-8 pt-12 border-t border-border">
          <a href="/" className="text-muted-foreground hover:text-primary transition-colors font-medium">
            Home
          </a>
          <a href="/workspace" className="text-muted-foreground hover:text-primary transition-colors font-medium">
            Workspace
          </a>
          <a href="/auth" className="text-muted-foreground hover:text-primary transition-colors font-medium">
            Sign In
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
